import React from "react";
import "../styles/Experience.scss";
import { motion } from "framer-motion";

const Experience = () => {
    const timelineVariants = {
      hidden: { opacity: 0, y: 50 },
      visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
      }),
    };

    return (
      <section id="experience" className="wrapper experience">
      <h2 className="section-title">Experience</h2>
      <div className="timeline-entries">
        {[
        {
          year: "9/2025",
          range: " - 2021",
          title: "Principal Front-end Engineer - Oracle, New York (remote)",
          description:
          "Principal engineer on web team, building and maintaining the design language and component system for oracle.com, along with tools and custom React apps to optimize the design team workflow.",
        },
        {
          year: "2021",
          range: " - 2018",
          title: "Senior Front-end Engineer - J.P. Morgan Chase, New York",
          description:
          "Built the React UI Toolkit used firmwide, along with headless microsites in React and WordPress.",
        },
        {
          year: "2018",
          range: " - 2017",
          title: "Front-end Developer - AMC Networks, New York",
          description: "Rebuilt sundancenow.com and shudder.com.",
        },
        {
          year: "2016",
          range: " - 2016",
          title: "Prototype Developer - E*Trade, New York",
          description:
          "Developed components and design style guide with custom Bootstrap SASS library and EJS templates for etrade.com.",
        }
        ].map((entry, index) => (
        <motion.div
          className="timeline-entry"
          key={index}
          custom={index}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          variants={timelineVariants}
        >
          <div className="timeline-date">
          <span className="year">{entry.year}</span>
          <span className="range">{entry.range}</span>
          </div>
          <div className="timeline-content">
          <h3 className="timeline-title">{entry.title}</h3>
          <p className="timeline-description">{entry.description}</p>
          </div>
        </motion.div>
        ))}
      </div>
      </section>
    );
};

export default Experience;
